module.exports = __webpack_public_path__ + "static/media/editorialCodeDarkDesktop.b70678cd.png";